import { Injectable } from '@angular/core';
import { toolNameToShapeType } from '../../../cross-team-shared/annotation/shared/abstract-tool';
import { ShapeState2D } from '../../../cross-team-shared/annotation/shared/state/shape-state';
import { ToolsHelperService } from '../../../cross-team-shared/misc-services/tools-helper.service';
import { Point2D } from '../../../team-apis/otterdam/answers/shape-typings';
import { AbstractSensorContentStore2D } from '../state/abstract-sensor-content-store-2d';
import { ImageBoundsService } from '../tools/edit/image-bounds.service';

@Injectable()
export class ShapeValidationService {
  constructor(
    private imageBoundsService: ImageBoundsService,
    private store: AbstractSensorContentStore2D,
    private toolsHelperService: ToolsHelperService,
  ) {}

  validate(shape: ShapeState2D, isForSingleFrame = true) {
    const validations = [
      this.isShapeTypeValid,
      this.validateKeyLocationPointsInBounds,
    ].map((validationFunction) => validationFunction.bind(this));

    for (const validation of validations) {
      const errorMessage = validation(shape, isForSingleFrame);
      if (errorMessage) {
        return errorMessage;
      }
    }

    return undefined;
  }

  private isShapeTypeValid(shape: ShapeState2D) {
    let errorMessage: string | undefined;
    // if the ToolManagerService is injected at the constructor level
    // the TOOLS_TOKEN will not be fully loaded causing the Keypoint Tool
    // to throw an error, since it depends on the output.meta
    const availableTools = this.toolsHelperService.getAllowedTools(
      this.store.state().output.name,
    );

    const availableShapeTypes = [...availableTools].map(toolNameToShapeType);
    if (!availableShapeTypes.includes(shape.type)) {
      errorMessage = `${shape.type} is not a valid shape type`;
    }
    return errorMessage;
  }

  private validateKeyLocationPointsInBounds(
    shape: ShapeState2D,
    isForSingleFrame: boolean,
  ) {
    let keyLocations = [shape.key_locations[0]];
    if (!isForSingleFrame) {
      keyLocations = shape.key_locations;
    }
    for (const keyLocation of keyLocations) {
      const points = keyLocation.points;
      const error = this.validatePointsInBounds(points);
      if (error) {
        return error;
      }
    }
    return undefined;
  }

  private validatePointsInBounds(points: Point2D[]) {
    for (const point of points) {
      if (!this.imageBoundsService.isInBounds(point)) {
        return `Point (${point[0]}, ${point[1]}) is out of bounds`;
      }
    }
    return undefined;
  }
}
